/* Video gallery slider section
--------------------------------------*/

// import Swiper from "../vendors/swiper";

class VideoGallerySlider {
  constructor(parent) {
    this.parent = parent;
    if (!this.parent) {
      return;
    }
    this.slider();
  }

  slider = () => {
    let sliders = qsa('.video-gallery-slider-js');
    if (sliders.length > 0) {
      sliders.forEach(element => {
        let videoSliderSectionId = element.dataset.id;
        let videoSliderSlide = element.dataset.slide;
        let videoSliderClass = `.video-gallery-slider-js.${videoSliderSectionId}`;
        let currentSlides = qsa(".swiper-slide",element)
        if (window.innerWidth < 768) {
          this.videoSlider(videoSliderClass, videoSliderSlide);
        }else{
          if(element.classList.contains('slider-for-desktop') && currentSlides.length >= Number(videoSliderSlide)){
            this.videoSlider(videoSliderClass, videoSliderSlide);
          }
        }
      });
    }
  }
  videoSlider = (sliderClass, videoSliderSlide) => {
    const recommendationSlider = new Swiper(sliderClass, {
      loop: false,
      slidesPerView: videoSliderSlide,
      slidesPerGroup: 1,
      shortSwipes: true,
      shortSwipesRatio: 0,
      speed: 1000,
      resistanceRatio: 0.4,
      spaceBetween: 20,
      breakpoints: {
        1: {
          slidesPerView: 1.35,
          spaceBetween: 10,
          resizeReInit: true,
          pagination: false,
          navigation: false,
          centeredSlides: true,
          loop: false,
          centeredSlidesBounds:false,
          initialSlide:1
        },
        768: {
          slidesPerView: 3.25,
          resizeReInit: true,
          spaceBetween: 10,
          pagination: false,
          navigation: false,
        },
        1024: {
          slidesPerView: videoSliderSlide,
        },
      },

      // Navigation arrows
      navigation: {
        nextEl: `${sliderClass} ~ .swiper-button-next.video-gallery-arrow`,
        prevEl: `${sliderClass} ~ .swiper-button-prev.video-gallery-arrow`,
      },
    });
  }

}

new VideoGallerySlider(qsa('.video-gallery-slider-js'));
